import IconCaution from "../../../svgs/icon_caution.svg";
import styles from "@/styles/Form.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import processStyles from "@/styles/Process.module.scss";

export default function ErrorMessage({ msg, inModal, processHeadingCaution }) {
  if (!msg) return null;
  return (
    <>
      {!inModal && !processHeadingCaution && (
        <span className={styles.errorMessage}>
          <span className={styles.iconCaution}>
            <IconCaution />
          </span>
          {msg}
        </span>
      )}
      {inModal && (
        <h4 className={modalStyles.errorMessageHeading}>
          <span className={modalStyles.iconCaution}>
            <IconCaution />
          </span>
          {msg}
        </h4>
      )}
      {processHeadingCaution && (
        <p className={processStyles.processHeadingCaution}>
          <span className={processStyles.iconCaution}>
            <IconCaution />
          </span>
          {msg}
        </p>
      )}
    </>
  );
}
